import { FuseNavigation } from '@theme/types';

export const navigation: FuseNavigation[] = [
  {
    id: 'daily',
    title: 'Hme',
    translate: 'Home',
    type: 'item',
    icon: 'home',
    url: '/daily'
  },
  {
    id: 'home',
    title: 'Staff Directory',
    translate: 'Staff Directory',
    type: 'item',
    icon: 'home',
    url: '/daily'
  },
];
